import React from 'react';
import { Facebook, Instagram, Mail, Phone, MapPin } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../utils/mockData';

const Footer = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: t.nav.home, href: '#home' },
    { label: t.nav.about, href: '#about' },
    { label: t.nav.services, href: '#services' },
    { label: t.nav.portfolio, href: '#portfolio' }
  ];

  const serviceLinks = [
    { label: language === 'en' ? 'Painting' : 'Pintura', href: '#services' },
    { label: language === 'en' ? 'Carpentry' : 'Carpintería', href: '#services' },
    { label: language === 'en' ? 'Remodeling' : 'Remodelación', href: '#services' },
    { label: language === 'en' ? 'Maintenance' : 'Mantenimiento', href: '#services' }
  ];

  const scrollToSection = (href) => {
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-gradient-to-b from-slate-900 to-slate-950 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_gr8-cabos/artifacts/1rmwygdl_612441855_1233419332106209_8852877029809590516_n.jpg"
              alt="GR8 Logo"
              className="h-20 w-auto mb-6"
            />
            <p className="text-slate-400 leading-relaxed mb-6">
              {t.footer.description}
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://facebook.com/loscabos.gr8" 
                target="_blank"
                rel="noopener noreferrer"
                className="bg-slate-800 w-10 h-10 rounded-full flex items-center justify-center hover:bg-amber-600 transition-colors duration-200"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a 
                href="https://instagram.com/loscabos.gr8/" 
                target="_blank"
                rel="noopener noreferrer"
                className="bg-slate-800 w-10 h-10 rounded-full flex items-center justify-center hover:bg-amber-600 transition-colors duration-200"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a 
                href="mailto:services@loscabosgr8.com" 
                className="bg-slate-800 w-10 h-10 rounded-full flex items-center justify-center hover:bg-amber-600 transition-colors duration-200"
              >
                <Mail className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-6" style={{ fontFamily: 'Arial, sans-serif' }}>
              {t.footer.quickLinks}
            </h3>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-slate-400 hover:text-amber-400 transition-colors duration-200"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-xl font-bold mb-6" style={{ fontFamily: 'Arial, sans-serif' }}>
              {t.footer.servicesTitle}
            </h3>
            <ul className="space-y-3">
              {serviceLinks.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-slate-400 hover:text-amber-400 transition-colors duration-200"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-6" style={{ fontFamily: 'Arial, sans-serif' }}>
              {t.contact.info.title}
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <Mail className="h-5 w-5 text-amber-400 mt-1 flex-shrink-0" />
                <a href="mailto:services@loscabosgr8.com" className="text-slate-400 hover:text-amber-400 transition-colors break-all">
                  services@loscabosgr8.com
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Phone className="h-5 w-5 text-amber-400 mt-1 flex-shrink-0" />
                <a href="tel:+5216243001035" className="text-slate-400 hover:text-amber-400 transition-colors">
                  +52 624 300 1035
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-amber-400 mt-1 flex-shrink-0" />
                <span className="text-slate-400">
                  Los Cabos, B.C.S.<br />México
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-slate-400 text-sm">
              © {currentYear} GR8. {t.footer.rights}
            </p>
            <p className="text-slate-400 text-sm">
              {language === 'en' 
                ? 'Made with excellence in Los Cabos' 
                : 'Hecho con excelencia en Los Cabos'}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
